import { DataGrid } from "@/components/DataGrid";
import { useClientConsumeDetails } from "@/features/accountSettings/api";
import {
  type GridColDef,
  type GridRenderCellParams,
} from "@mui/x-data-grid-pro";
import { format } from "date-fns";
import { useMemo } from "react";
import { formatNumberWithComma } from "@/utils/formatNumber";

interface ConsumeCreditHeaders
  extends Omit<GridColDef, "field" | "headerName" | "width"> {
  field: keyof ConsumeCreditRow;
  headerName: string;
  width: number;
}

interface ConsumeCreditRow {
  id: number;
  userName: string;
  date: string;
  item: string;
  quantity: number;
  price: string;
}

interface Props {
  date: Date;
}

const column: ConsumeCreditHeaders[] = [
  {
    field: "date",
    headerName: "日時",
    width: 180,
  },
  {
    field: "userName",
    headerName: "ユーザー",
    width: 220,
  },
  {
    field: "item",
    headerName: "商品",
    width: 220,
  },
  {
    field: "quantity",
    headerName: "数量",
    width: 120,
    renderCell: ({ value }: GridRenderCellParams<number, ConsumeCreditRow>) =>
      formatNumberWithComma(value),
  },
  {
    field: "price",
    headerName: "小計",
    width: 120,
    renderCell: ({ value }: GridRenderCellParams<string, ConsumeCreditRow>) =>
      formatNumberWithComma(value),
  },
];

export const ClientConsumeCreditGrid: React.FC<Props> = (props) => {
  const { date } = props;
  const consumeDetailsRes = useClientConsumeDetails(
    date.getFullYear(),
    date.getMonth() + 1
  );
  const consumeDetails = useMemo(
    () =>
      consumeDetailsRes.map<ConsumeCreditRow>((consumeDetail) => {
        return {
          id: consumeDetail.id,
          userName: consumeDetail.userName,
          item: consumeDetail.itemName,
          quantity: consumeDetail.quantity,
          price: consumeDetail.consumeCredit.toLocaleString(),
          date: format(new Date(consumeDetail.createdAt), "yyyy/MM/dd"),
        };
      }),
    [consumeDetailsRes]
  );
  return <DataGrid rows={consumeDetails} columns={column}></DataGrid>;
};
